<template>
  <div>
    <div class="centered-column">
      <div class="container-header">
        <h3>{{ company_name }}</h3>
      </div>
      <div class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{ label.get("account") }}</label>
          </div>
          <button class="update-btn" @click="updateCompanyName">
            <i class="atto atto-edit-btn-sv" />
            {{ label.get("update_company_name") }}
          </button>
        </div>
        <div class="content-wrapper account-section">
          <div class="d-flex flex-column">
            <div class="d-flex flex-row align-items-center">
              <label>{{ label.get("company_name") }}</label>
              <span>{{ company_name }}</span>
            </div>
            <hr class="separator-line" />
            <div class="d-flex flex-row align-items-center">
              <label>{{ label.get("account_owner") }}</label>
              <span>{{ email }}</span>
            </div>
          </div>

          <div>
            <div class="wrapper">
              <span class="label-wrap">
                <i class="atto atto-rdir-arrow-b" />
                {{ label.get("currency") }}
              </span>
              <select-dropdown-component
                :value="currency_id"
                :options="currencies"
                @onOptionSelected="onChangeSaveCurrency"
              />
            </div>
            <p class="currency-desc">{{ label.get("currency_in_use") }}</p>
          </div>
        </div>
      </div>
      <div class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">
              {{ label.get("transfer_account_ownership") }}</label
            >
          </div>
        </div>
        <div class="content-wrapper transfer-section">
          <div
            class="d-flex flex-row justify-content-between align-items-center"
          >
            <p>
              {{ label.get("transfer_account_ownership_description") }}
            </p>
            <button
              class="atto-btn black-btn md-btn"
              @click="transferOwnership"
            >
              {{ label.get("choose_new_owner") }}
            </button>
          </div>
        </div>
      </div>
      <div class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{
              label.get("deactivate_account")
            }}</label>
          </div>
        </div>
        <div class="content-wrapper deactivate-section">
          <div
            class="d-flex flex-row justify-content-between align-items-center"
          >
            <p>{{ label.get("deactivate_account_description") }}</p>
            <button
              class="atto-btn deactivate md-btn"
              @click="deactivateAccount"
            >
              {{ label.get("deactivate_account") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <transfer-ownership-modal-component
      v-if="showTransferOwnership"
      :admins="admins"
    />
    <deactivate-account-confirm-password-component
      v-if="showDeactivateAccountConfirmPassword"
    />
    <transfer-ownership-confirm-password-component
      v-if="showTransferOwnershipConfirmPassword"
    />
    <update-company-name-component v-if="showUpdateCompanyName" />
  </div>
</template>

<script>
import AuthService from "../../../shared/services/AuthService";
import CompanyService from "./services/CompanyService";
import TransferOwnershipModalComponent from "./components/TransferOwnershipModalComponent";
import DeactivateAccountConfirmPasswordComponent from "./components/DeactivateAccountConfirmPasswordComponent";
import TransferOwnershipConfirmPasswordComponent from "./components/TransferOwnershipConfirmPasswordComponent";
import { required } from "vuelidate/lib/validators";
import DisconnectQuickbookAccountComponent from "./components/DisconnectQuickbookAccountComponent";
import UpdateCompanyNameComponent from "./components/UpdateCompanyNameComponent";
import SelectDropdownComponent from "../../../shared/components/SelectDropdownComponent";

export default {
  name: "CompanyComponent",
  components: {
    SelectDropdownComponent,
    UpdateCompanyNameComponent,
    TransferOwnershipModalComponent,
    DeactivateAccountConfirmPasswordComponent,
    TransferOwnershipConfirmPasswordComponent,
  },
  data() {
    return {
      editName: false,
      company_name: this.$store.state.company.name,
      isOwner: this.$store.state.user.is_owner,
      admins: [],
      deactivate: false,
      hasError: false,
      selectedTransferAccount: null,
      showTransferOwnership: false,
      showTransferOwnershipConfirmPassword: false,
      showDeactivateAccountConfirmPassword: false,
      email: this.$store.state.user.email,
      showUpdateCompanyName: false,
      currency_id: this.$store.state.companySettings.currency_id,
    };
  },
  computed: {
    isConnectedToQuickbooks() {
      return this.$store.state.isConnectedToQuickbooks;
    },
    currencies() {
      return this.$store.state.currencies.map((item) => {
        return {
          value: item.id,
          label: item.name,
        };
      });
    },
  },
  validations: {
    company_name: {
      required,
    },
  },
  mounted() {
    this.getAdmins();
    this.$root.$on("hideTransferOwnership", this.hideTransferOwnership);
    this.$root.$on(
      "hideTransferOwnershipConfirmPassword",
      this.hideTransferOwnershipConfirmPassword
    );
    this.$root.$on(
      "hideDeactivateAccountConfirmPassword",
      this.hideDeactivateAccountConfirmPassword
    );
    this.$root.$on("hideUpdateCompanyName", this.hideUpdateCompanyName);
  },
  beforeDestroy() {
    this.$root.$off("hideTransferOwnership");
    this.$root.$off("hideTransferOwnershipConfirmPassword");
    this.$root.$off("hideDeactivateAccountConfirmPassword");
  },
  methods: {
    editCompanyName: function() {
      this.editName = true;
      this.$nextTick(() => {
        this.$refs.companyName.focus();
      });
    },

    cancelEdit: function() {
      this.company_name = this.$store.state.company.name;
      this.editName = false;
    },

    /*changeName: function () {
              debugger;
                this.$v.company_name.$touch();
                debugger;
                if (this.$v.company_name.$invalid) {
                  debugger;
                    this.hasError = true;
                    debugger;
                    return false;
                }
                if (!this.editName) {
                  debugger;
                    return false;
                }
                this.hasError = false;
                debugger;
                if (this.company_name !== this.$store.state.company.name) {
                  debugger;
                    this.editName = false;
                    debugger;
                    const data = {
                        name: this.company_name
                    };
                    debugger;
                    CompanyService.updateCompanyName(data).then(response => {
                      debugger;
                        this.hasError = false;
                        this.$store.state.company.name = this.company_name;
                        this.originalName = this.company_name;
                  debugger;
                        this.$awn.success(response.data.message);
                        debugger;
                    }).catch(error => {
                      debugger;
                        this.editName = true;
                    });
                    debugger;
                } else {
                    this.editName = false;
                }
            },*/
    updateCompanyName: function() {
      this.showUpdateCompanyName = true;
    },
    hideUpdateCompanyName: function() {
      this.company_name = this.$store.state.company.name;
      this.showUpdateCompanyName = false;
    },
    getAdmins: function() {
      const ownerId = this.$store.state.company.user_id;
      this.admins = this.$store.state.members
        .filter((item) => {
          return item.role_id === 1 && item.id !== ownerId;
        })
        .map((item) => {
          return {
            id: item.id,
            name: item.name,
            role_id: item.role_id,
          };
        });
      /*CompanyService.getCompanyAdmins().then(response => {
                    this.admins = response;
                }).catch(error => {
                    console.log(error);
                });*/
    },

    transferOwnership: function() {
      this.showTransferOwnership = true;
    },

    deactivateAccount() {
      this.showDeactivateAccountConfirmPassword = true;
    },

    disconnectQuickbookModal() {
      this.$root.$emit("showDisconnectQuickbookAccount");
    },

    hideTransferOwnership(member) {
      this.showTransferOwnership = false;
      if (member) {
        this.selectedTransferAccount = member;
        this.$nextTick(() => {
          this.showTransferOwnershipConfirmPassword = true;
        });
      }
    },

    hideTransferOwnershipConfirmPassword(success) {
      this.showTransferOwnershipConfirmPassword = false;
      if (success && this.selectedTransferAccount) {
        this.$store.commit("showLoading");
        CompanyService.transferOwnership({
          id: this.selectedTransferAccount.id,
        })
          .then((response) => {
            this.$store.commit("hideLoading");
            this.$awn.success(response.data.message);
          })
          .catch((error) => {
            console.log(error);
            this.$store.commit("hideLoading");
          });
      } else {
        this.selectedTransferAccount = null;
      }
    },

    hideDeactivateAccountConfirmPassword(deactivated) {
      this.showDeactivateAccountConfirmPassword = false;
      if (deactivated) {
        AuthService.logOut();
        window.location.href = "https://attotime.com";
      }
    },
    onChangeSaveCurrency(selected) {
      const selectedCurrencyId = selected.value;
      if (selectedCurrencyId !== this.currency_id) {
        this.$store.state.companySettings.currency_id = selectedCurrencyId;
        CompanyService.updateCompanySettings(this.$store.state.companySettings)
          .then((response) => {
            this.$awn.success(response.data.message);
          })
          .catch(() => {});
      }
    },
  },
};
</script>

<style lang="scss" scoped>
div.company-details {
  padding: 40px 0 0;

  > h4.section-subtitle {
    margin-bottom: 32px;
  }

  .info-field {
    display: flex;
    flex-direction: row;
    min-width: 240px;
    margin-bottom: 6px;
    align-items: center;
    flex-wrap: wrap;
    position: relative;

    .company-name {
      margin-bottom: 0;
      padding: 6px;
      border: 2px solid #efefef;
      display: flex;
      flex-direction: row;
      max-width: 100%;
      min-width: 400px;

      h5 {
        font-size: 1rem;
        line-height: 1.5rem;
        font-family: "Roboto", sans-serif;
        font-weight: 500;
        color: #262626;
      }
    }

    input {
      width: 320px;
      border: 2px solid #efefef;
      padding: 0 10px;
      font-family: "Roboto", sans-serif;
      line-height: 36px;
      color: #262626;

      &.name-input {
        font-size: 1.5rem;
        line-height: 36px;
        font-weight: 500;
      }

      &:focus {
        border-color: #00b9cb;
      }

      &.error {
        border-color: #e05656;
      }
    }

    span.mail {
      display: inline-flex;
      font-size: 1rem;
      line-height: 40px;
      font-family: "Roboto", sans-serif;
      color: #262626;
      font-weight: 400;
    }

    button.edit {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      padding: 0;
      margin-left: auto;
      width: 24px;
      height: 24px;

      i {
        display: inline-flex;
        width: 24px;
        height: 24px;
        justify-content: center;
        align-items: center;

        &:before {
          font-size: 18px;
          color: #c7c7c7;
          @include base-transition(ease color 0.2s);
        }
      }

      &:hover {
        cursor: pointer;

        i {
          &:before {
            color: #262626;
          }
        }
      }
    }

    button.change {
      width: 100px;
      margin-left: 16px;
      font-size: 1rem;
      font-family: "Roboto", sans-serif;
      font-weight: 400;
      color: #fff;
      text-transform: uppercase;
      display: inline-flex;
      justify-content: center;
    }

    .change-alert {
      position: absolute;
      left: 0;
      bottom: calc(-100% - 6px);
      flex-grow: 2;
      width: 100%;
      display: inline-flex;
      font-size: 0.875rem;
      line-height: 1.25rem;
      font-family: "Roboto", sans-serif;
      font-weight: 400;
      color: #e05656;
      max-width: 540px;
      margin-top: 6px;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  hr.separator {
    width: 80px;
    height: 2px;
    background-color: #efefef;
    margin: 40px 0 32px 0;
    border: 0;
  }

  p {
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 400;
    font-family: "Roboto", sans-serif;
    color: #999;
  }

  button.submit {
    width: 300px;
    text-transform: uppercase;
  }

  .transfer-account-ownership {
    h4.section-subtitle {
      margin-bottom: 12px;
    }

    p {
      width: 600px;
      max-width: 100%;
      margin-bottom: 32px;
    }
  }

  .deactivate-account {
    width: 320px;
    max-width: 100%;

    hr.separator {
      margin-top: 160px;
    }

    .deactivate {
      display: inline-flex;
      font-size: 1.125rem;
      line-height: 1.5rem;
      font-weight: 500;
      font-family: "Roboto", sans-serif;
      color: #e05656;
      margin-bottom: 20px;
      cursor: pointer;
    }

    p {
      margin-bottom: 0;
      display: inline-flex;
    }
  }

  /* ----- Quickbooks added styles  ----- */

  .form-wrapper .form-group a.connect-to-quickbooks {
    padding: 0 15px;
    line-height: 38px;
    height: 38px;
    background-color: transparent;
    width: 100%;
    border: 1px solid #e1e1e3;
    border-radius: 5px;
    font-size: 15px;
    color: #4f5057;
    -webkit-transition: ease all 0.15s;
    -moz-transition: ease all 0.15s;
    -ms-transition: ease all 0.15s;
    -o-transition: ease all 0.15s;
    transition: ease all 0.15s;
  }

  .form-wrapper .form-group a.connect-to-quickbooks {
    transition: none !important;
  }

  a.connect-to-quickbooks {
    display: block;
  }

  /*a.connect-to-quickbooks span {*/
  /*    !*background: url("../images/connect_to_quickbooks.svg") no-repeat center;*!*/
  /*    width: 180px;*/
  /*    height: 36px;*/
  /*    display: block;*/
  /*}*/

  /*a.connect-to-quickbooks:hover {*/
  /*    border: 1px solid #329e28 !important;*/
  /*}*/

  .qb-integrations {
    h4.section-subtitle {
      margin-bottom: 32px;
    }

    .status-wrapper {
      display: flex;
      flex-direction: column;
      p {
        margin-bottom: 0;
        font-size: 0.75rem;
        line-height: 1rem;
        font-family: $roboto-font;
        color: $atto-font-color;
        font-weight: $roboto-medium;
      }

      span {
        font-size: 0.875rem;
        line-height: 1.125rem;
        font-family: $roboto-font;
        color: #479f46;
        font-weight: $roboto-medium;
      }
    }

    i.qb-icon {
      width: 28px;
      height: 28px;
      margin-right: 13px;
      background: url("~@assets/images/quickbooks-icon.svg");
      background-size: 28px;
    }

    .qb-btn {
      min-width: 300px;
      border: 2px solid $atto-light-grey;
      @include base-transition(ease all 0.15s);
      display: inline-flex;
      padding: 10px 20px;
      justify-content: center;
      align-items: center;

      font-size: 1.125rem;
      font-family: "Roboto", sans-serif;
      line-height: 2rem;
      color: #479f46;
      font-weight: 500;

      &:hover {
        border-color: $atto-dark-grey;
      }

      .connect-image {
        display: inline-flex;
        width: 217px;
        height: 28px;
        background-image: url("~@assets/images/connect-icon.svg");
        background-size: contain;
        background-repeat: no-repeat;
      }
    }

    &.disconnect-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;

      .middle-line {
        height: 44px;
        width: 2px;
        background-color: #efefef;
        margin: 0 30px;
        display: inline-flex;
        border: 0;
      }

      .disconnect {
        font-size: 0.875rem;
        line-height: 1.125rem;
        font-family: $roboto-font;
        color: $atto-font-color;
        font-weight: $roboto-medium;
        @include base-transition(ease all 0.15s);
        &:hover {
          color: #479f46;
        }
      }
    }
  }
}

.update-btn {
  width: auto;
}
.separator-line {
  width: 40px;
  margin: 10px 0;
  border-top: 2px solid rgba(0, 0, 0, 0.1);
}
.account-section {
  display: flex;
  justify-content: space-between;

  label {
    font: $roboto-regular 0.9375rem/1.75rem $roboto-font;
    padding: 0;
    min-width: 108px;
    margin: 0 66px 0 0;
  }
  span {
    font: $roboto-medium 1rem/2rem $roboto-font;
    margin: 0;
    padding: 0;
  }
  .wrapper {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    height: 40px;
    min-width: 387px;
    align-items: center;

    .label-wrap {
      font: 400 0.875rem/1.75rem "Roboto", sans-serif;
      color: #262626;
      text-transform: capitalize;

      i {
        font-size: 0.6875rem;
        margin-right: 7px;
      }
    }
    .atto-select {
      min-width: 270px;
    }
  }
  .currency-desc {
    color: #666666;
    font: $roboto-regular 0.875rem/1.25rem $roboto-font;
    text-align: left;
    max-width: 270px;
    width: 100%;
    padding: 12px 12px 0;
    margin-left: auto;
  }
}
.content-wrapper {
  p {
    font: $roboto-regular 0.875rem/1.25rem $roboto-font;
    margin: 0;
    max-width: 520px;
    width: 50%;
  }
}
.atto-btn.deactivate {
  text-transform: uppercase;
}

@media (max-width: 1185px) {
  .settings-page {
    .white-card {
      .content-wrapper {
        flex-flow: column;
        align-items: flex-start;

        .wrapper {
          margin-top: 40px;
          min-width: 440px;
        }
      }
    }
  }
}
</style>

<style lang="scss"></style>
